import { Injectable, NgModule, ModuleWithProviders, SkipSelf } from '@angular/core';
import { HttpModule, Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

//import { AdalModule, AdalHttp } from './adal.http.service';

//@Injectable() 
export class AzureAdConfig {
    public tenant: string;
    public clientId: string;
    public redirectUri: string;
    public postLogoutRedirectUri: string;
    public redirectPath: string;
}

//@NgModule({
//    imports: [HttpModule],
//    //providers: [Http]//AdalService, AdConfigService]
//})
//export class AppSettingsModule {
//    static withConfig(): ModuleWithProviders {
//        return {
//            ngModule: AppSettingsModule,
//            providers: [

//                provideAppSettingsConfig()
//            ]
//        }
//    }
//}

//export function provideAppSettingsConfig(): any[] {
//    return [

//        {
//            provide: AppSettingsService, useFactory: (http: Http) => { return new AppSettingsService(http)} , deps: [Http]
//        }
//    ];
//}

@Injectable()
export class AppSettingsService {
    private redirectPath: string;
    public ApiUrl: string = window.location.protocol + '//' + window.location.host + "/api/appsettings";
    private headers: Headers;
    public adalConfigSettings: AzureAdConfig;

    //constructor(private _http: Http) {
    //    this.redirectPath = '';
    //    //this.headers = new Headers();
    //    //this.headers.append('Content-Type', 'application/json');
    //    //this.http.get(this.ApiUrl).map((response: Response) => {
    //    //    this.adalConfigSettings = <any>response.json()
    //    //}).catch(this.handleError); 
    //}
    constructor(private http: Http) {

        //this.actionUrl = _configuration.ServerWithApiUrl + 'asset/';

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        //this.http.get(this.ApiUrl, { headers: this.headers }).map((response: Response) => {
        //    this.adalConfigSettings = <any>response.json()
        //}).catch(this.handleError); 

        //this.adalConfigSettings = this.http.get(this.ApiUrl, { headers: this.headers }).map((response: Response) => {
        //    let r = response.json();
        //    return r.body || [];
        //}).catch(this.handleError);

        //this.http.get(this.ApiUrl, { headers: this.headers })
        //    .map((res: Response) => res.json())
        //    .subscribe(
        //    data => {
        //        this.adalConfigSettings = data
        //    },
        //    err => console.error(err),
        //    () => console.log('done')
        //    );

    }
    //constructor(injector: Injector) {
    //    let _http = injector.get(Http);
    //}

    public get adalConfig(): AzureAdConfig {
        //return { clientId }

        return this.adalConfigSettings;

        //return { 
        //    tenant: this.adalConfigSettings[1], // '1840e87d-65f7-48a3-a5ef-cdf3448f8f49', //'dsentienceiot002.onmicrosoft.com',
        //    clientId: this.adalConfigSettings[2], // 'c5aecf51-0079-47e3-97c7-7ede16b513db',//'ff2599fe-1285-4869-9dbf-7dc1da2ce81c',
        //    redirectUri: window.location.origin + '/' + this.redirectPath,
        //    postLogoutRedirectUri: window.location.origin + '/',
        //    redirectPath: this.redirectPath
        //};
        //return this.adalConfigSettings;
        //return {
        //    tenant: '1840e87d-65f7-48a3-a5ef-cdf3448f8f49', //'dsentienceiot002.onmicrosoft.com',
        //    clientId: 'c5aecf51-0079-47e3-97c7-7ede16b513db',//'ff2599fe-1285-4869-9dbf-7dc1da2ce81c',
        //    redirectUri: window.location.origin + '/' + this.redirectPath,
        //    postLogoutRedirectUri: window.location.origin + '/',
        //    redirectPath: this.redirectPath
        //};
    }

    getAppSettings(): Promise<AzureAdConfig> {
        //var promise = this.http.get(this.ApiUrl, { headers: this.headers }).map((response: Response) => {

        //    var res = response.json();
        //    return { tenant: res[1], clientId: res[2], postLogoutRedirectUri: "", redirectPath: "", redirectUri: "" };
        //}).toPromise();
        //promise.then(settings => {
        //    this.adalConfigSettings = settings;
        //});

        //return promise;
        //return Promise.resolve(this.adalConfigSettings);

        var observable = this.http.get(this.ApiUrl, { headers: this.headers })
            .map((response: Response) => {

                var res = response.json();
                return { tenant: res[1], clientId: res[2], postLogoutRedirectUri: res[3], redirectPath: "", redirectUri: res[3] };
            });

        observable.subscribe(user => {
        this.adalConfigSettings = user;
        console.log(this.adalConfigSettings)
        });
        var pr = observable.toPromise();
        //pr.then(set => {
        //    this.adalConfigSettings = set
        //    console.log(set);
        //}
        //);
        return pr;

        
    }


    load() : Promise<AzureAdConfig> {
        return new Promise((resolve) => {
            this.http.get(this.ApiUrl, { headers: this.headers }).map(res => res.json())
                .subscribe(config => {
                    this.adalConfigSettings = { tenant: config[1], clientId: config[2], postLogoutRedirectUri: config[3], redirectPath: "", redirectUri: config[3] };
                    localStorage.setItem("sent-cfg", JSON.stringify(this.adalConfigSettings));
                    resolve();
                });
        });
        } 

    //load(): Promise<AzureAdConfig> {
    //    this.http.get("/blah/config.json")
    //        .map(res => res.json())
    //        .subscribe((env_data) => {
    //            console.log(env_data);
    //        });
    //    this.config = new Config("localhost", "5050");
    //    return Promise.resolve(this.config);
    //}

    public loadC(): Promise<void> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let url = this.ApiUrl;

        return this.http.get(url, { headers }).toPromise().
            then(config => {
                this.adalConfigSettings = { tenant: config[1], clientId: config[2], postLogoutRedirectUri: config[3], redirectPath: "", redirectUri: config[3] };
            }).catch(err => {
                console.log(err);
            });
    }

    public setRedirectPath(value: string) {
        this.adalConfigSettings.redirectPath = value;
    }

    public setRedirectUri(value: string) {
        this.adalConfigSettings.redirectUri = value;
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }
}


// WEBPACK FOOTER //
// ./app/services/appsettings.service.ts